import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { GetStocksParams, getStockCount } from '@apis/stock';
import { dropEmptyValues } from '../../utils/common';

export const useStockCount = (searchParam: GetStocksParams) => {
  /**
   * IMPORTANT:
   * The count query result depends on all active filters.
   * Include the "effective" request params in the query key to avoid stale results.
   */
  const cleanedSearch = dropEmptyValues(searchParam, [
    'stockCode',
    'stockName',
    'regionId',
    'supplierId',
    'status',
    'ordering',
  ]);

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['stocksCount', cleanedSearch],
    queryFn: () => getStockCount(cleanedSearch),
  };

  return useQuery(queryOptions);
};
